export const BORDER_COLOR = "D9D9D9"; // Beyaz %15 koyu (85% beyaz)
export const HEADER_FILL_COLOR = "F2F2F2"; // Beyaz %5 koyu (95% beyaz)